'use strict';
'use es6';

/**
 * Returns document.activeElement _if_ it's a valid HTMLElement.
 *
 * @param  {Document} [htmlDocument=window.document]
 * @return {?HTMLElement}
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveElement = getActiveElement;
exports.blurActiveElement = blurActiveElement;
function getActiveElement() {
  var htmlDocument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;

  var activeElement = htmlDocument.activeElement;
  // In certain cases IE will return an invalid element that throws an
  // "Object doesn't support property or method 'blur'" error if
  // we call `.blur()` on it. If the element's `nodeName` is undefined
  // it's invalid.
  if (!activeElement || activeElement.nodeName === undefined) {
    return null;
  }
  return activeElement;
}

/**
 * Blurs document.activeElement if possible. Accounts for cross-browser
 * inconsistencies.
 *
 * @param  {Document} [htmlDocument=window.document]
 */
function blurActiveElement() {
  var htmlDocument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;

  var activeElement = getActiveElement(htmlDocument);
  if (activeElement) {
    activeElement.blur();
  }
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/core/ActiveElement.js
// module id = 28
// module chunks = 0